import { formatDate, formatRelative } from '../../lib/format'

export interface ApiKeyRow {
	id: string
	name: string
	prefix: string
	created_at: string
	last_used_at: string | null
	revoked_at: string | null
	owner_email?: string
}

/** API keys with a revoke action; shows the owner column when present (an admin's account page lists everyone's). */
export function KeysTable({ keys, onRevoke }: { keys: ApiKeyRow[]; onRevoke(id: string): void }) {
	if (keys.length === 0) return <p className="muted">No API keys yet.</p>
	const showOwner = keys.some((k) => k.owner_email)
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>Name</th>
						<th>Key</th>
						{showOwner && <th>Owner</th>}
						<th>Created</th>
						<th>Last used</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{keys.map((k) => (
						<tr key={k.id} style={{ opacity: k.revoked_at ? 0.55 : 1 }}>
							<td>{k.name}</td>
							<td style={{ fontFamily: 'var(--mono)', fontSize: '0.85rem' }}>{k.prefix}…</td>
							{showOwner && <td className="small">{k.owner_email}</td>}
							<td className="muted small">{formatDate(k.created_at)}</td>
							<td className="muted small">{formatRelative(k.last_used_at)}</td>
							<td>
								{k.revoked_at ? (
									<span className="muted small">revoked</span>
								) : (
									<button type="button" className="danger" onClick={() => onRevoke(k.id)}>
										Revoke
									</button>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
